export enum FileTypeType {
	Zip = 'zip',
	Pdf = 'pdf'
}

export type OptionItem = {
	label: string;
};

export enum UnitType {
	Class,
	Group,
	None,
}

export interface UnitData {
	id: number;
	type: UnitType;
	name?: string;
}

export interface StudentWithUnit {
	studentId: number;
	unitData: UnitData,
}

export enum ColorType {
	BlackAndWhite = 'blackAndWhite',
	Colored = 'colored'
}

export enum DisplayType {
	Score = 'score',
	Percent = 'percent',
	Grade = 'grade'
}

export enum DisplayNotTestedType {
	NT = 'NT',
	Zero = 'Zero'
}

export interface ReportSettings {
	showBaseline: boolean,
	carryForward: boolean,
}